<template>
  <section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" lazy-validation>
            <v-card-title>Modification Duaa</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="duaaInfo.title"
                    label="Titre en français"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="duaaInfo.titleEn"
                    label="Titre en anglais"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <label class="subtitle-2 font-weight-medium" style="display:block; margin-bottom:8px;">Description en français</label>
                  <VueEditor
                    v-model="duaaInfo.description"
                    auto-grow
                    outlined
                    placeholder="Description en français"
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                    <label class="subtitle-2 font-weight-medium" style="display:block; margin-bottom:8px;">Description en anglais</label>
                  <VueEditor
                    v-model="duaaInfo.descriptionEn"
                    auto-grow
                    outlined
                    placeholder="Description en anglais"
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <vue-upload-multiple-image
                    v-if="duaaInfo.title && duaaInfo.description && duaaInfo.titleEn && duaaInfo.descriptionEn"
                    style="margin-left: 160px"
                    v-model="images"
                    :data-images="images"
                    accept="image/*	"
                    name="images"
                    drag-text="Veuillez ajoutez une images svp!"
                    browse-text="Browse image"
                    primary-text="Primary image"
                    mark-is-primary-text="Set default image"
                    :min-image="1"
                    :multiple="false"
                    :showEdit="false"
                    popup-text="Description default image"
                    drop-text="Drag and drop"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                  >
                  </vue-upload-multiple-image>
                  <v-progress-linear
                    v-if="showlowding && uploadPercentage < 100"
                    style="max-width: 190px; margin-left: 160px"
                    color="primary"
                    indeterminate
                    rounded
                    height="15"
                    ><strong
                      >{{ Math.ceil(uploadPercentage) }}%</strong
                    ></v-progress-linear
                  >
                </v-col>

                
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="duaaInfo.rank"
                    hide-details
                    outlined
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    label="Rank duaa"
                  />
                </v-col>
                <v-col cols="auto" style="margin-top: 16px">
                  <span>Premium:</span>
                </v-col>
                <v-col cols="auto">
                  <v-switch
                    v-model="duaaInfo.isLocked"
                    hide-details
                    inset
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      :disabled="
                        duaaInfo.rank.length <= 0 ||
                        duaaInfo.title.length <= 0 ||
                        !duaaInfo.titleEn ||
                        duaaInfo.description.length <= 0 ||
                        !duaaInfo.descriptionEn ||
                        !duaaInfo.imgDBId
                      "
                      class="info"
                      @click="ConfirmeEditDuaa()"
                    >
                      Modifier
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogEditDuaa" persistent max-width="600">
        <v-card>
          <v-card-title style="text-align: center" class="justify-center mb-2">
            Etes vous sur de vouloir modifier le duaa ?
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1 error" text @click="cancelleCallback">
              Annuler
            </v-btn>

            <v-btn
              color="info darken-1 "
              :loading="isLoading"
              text
              @click="Updateduaa()"
            >
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>
<script>
import firebase from "firebase/compat/app";
import store from "../../../store/image";

import "firebase/compat/storage";
import { component as VueCodeHighlight } from "vue-code-highlight";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import axios from "axios";
import Constant from "@/utils/constants";
import { getAllSurat, getAllduaa } from "@/views/qorani/services/services";
export default {
  components: { VueUploadMultipleImage, VueEditor, VueCodeHighlight },
  data() {
    return {
      dialogEditDuaa: false,
      isLoading: false,
      isLocked: false,
      uploadPercentage: null,
      fakePercentage: null,
      showlowding: false,
      images: [],
      duaaInfo: {
        id: "",
        title: "",
        titleEn: "",
        descriptionEn: "",
        description: "",
        imgUrlId: "",
        rank: "",
        isLocked: false,
      },
      duaas: [],
      duaa: {
        duaaId: "",
        title: "",
        description: "",
        imgDBUrlId: "",
        rank: "",
        isLocked: false,
      },
      imageInfo: {
        fileName: "",
        fileUrl: "",
      },
    };
  },

  async beforeRouteEnter(to, from, next) {
    const duaaId = to.params.id;
    try {
      const response = await axios.get(`${Constant.QORANI}duaa/get/${duaaId}`);
      next((vm) => {
        vm.duaaInfo = response.data;

        const imagePath = response.data.imgDBId
          ? vm.getImageUrl(response.data.imgDBId)
          : response.data.imageUrl;

        vm.images.push({
          name: "",
          path: imagePath,
          highlight: 1,
          default: 1,
        });
      });
    } catch (error) {
      console.error("Error fetching product details:", error);
      next(null);
    }
  },

  methods: {
    ConfirmeEditDuaa() {
      this.dialogEditDuaa = true;
    },
    async loadImage(item) {
      if (item.fileUrlDBType === "svg") {
        try {
          const response = await fetch(
            `${Constant.QORANI}fileDB/files/${item.fileUrlDBId}`
          );
          if (!response.ok)
            throw new Error("Échec du chargement de l'image SVG");

          let svgContent = await response.text();

          // Ajoute width et height directement dans le SVG
          svgContent = svgContent
            .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

          item.svgContent = svgContent; // Stockage dans l'objet item
        } catch (error) {
          console.error("Erreur lors du chargement de l'image :", error);
        }
      } else {
        item.imgUrl = `${Constant.QORANI}fileDB/files/${item.fileUrlDBId}`;
      }
    },

    getImageUrl(imgDBId) {
      return `${Constant.QORANI}fileDB/files/${imgDBId}`;
    },
    async Updateduaa() {
      this.isLoading = true;
      const imageId = store.state.imageId;

      this.duaa.title = this.duaaInfo.title;
      this.duaa.titleEn = this.duaaInfo.titleEn;
      this.duaa.description = this.duaaInfo.description;
      this.duaa.descriptionEn = this.duaaInfo.descriptionEn;
      // this.duaa.imgUrlId = this.duaaInfo.imgId;
      this.duaa.rank = this.duaaInfo.rank;
      this.duaa.isLocked = this.duaaInfo.isLocked;
      const responseCategorie = await fetch(
        Constant.QORANI + "duaa/edit/" + this.duaaInfo.id,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.duaa),
        }
      );

      try {
        this.$router.push({
          name: "duaa",
        });
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout du duaa, veuillez réessayez plus tard, Merci."
        );
      }
    },

    async uploadImageSuccess(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
        const imageId = store.state.imageId;
        this.duaa.imgDBUrlId = imageId;
        this.duaaInfo.imgDBId = imageId;

        // console.log("Image id :", imageId);
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },
    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.images.indexOf(fileList[index].path);
        this.duaaInfo.imageUrl = "";
        this.duaaInfo.imgId = "";
        this.duaaInfo.imgDBId=""
        if (index > -1) {
          this.images.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    convertImagePathToFile(element) {
      const byteString = atob(element.path.split(",")[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: "image/jpeg" });

      return new File([blob], element.name);
    },
  },
  async created() {},
};
</script>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
